export default {
    layout: {
        zh: 'Simplified Chinese',
        zhTw: 'Traditional Chinese',
        en: 'English',
        kr: 'Korean',
        jp: 'Japanese',
        copyAddress: 'Copy address',
        switchWallet: 'Switch wallet',
        disconnect: 'Disconnect',
        copied: 'Copied',
        failed:'failed',
        success:'success',
    },
    node: {
        progress: 'In progress',
        executionSuccessful: 'Successful',
        at: 'on',
        view: 'View',
    },
    menu: {
        home: 'Home',
        exchange: 'Swap',
        mining: 'Mining',
        assets: 'Assets',
        earnings: 'Earnings',
        me: 'Me',
        notice: 'Notice',
    },
    exchange: {
        title: 'Swap',
        send: 'Send',
        receive: 'Receive',
        obtain: 'Get',
        consume: 'Spend',
        balance: 'Balance',
        max: 'Max',
        currentPrice: 'Price',
        submit: 'Swap',
        records: 'History',
        price: 'Price',
        success: 'Success',
        fail: 'Failed',
    },
    home: {
        brand: 'OnOx',
        slogan: 'Connect globally, empower the future',
        sloganDesc: 'Decentralized · Open · Efficient',
        yield: 'APY',
        notice: 'Notice 1, ABC mining is live',
        todayOutput: 'Today pool output',
        networkHashrate: 'Network hashrate',
        price: 'Token price',
        burned: 'Total burned',
        aboutTitle: 'About ONOX hashrate mining',
        aboutDesc: 'ONOX connects real hashrate nodes and unifies output, settlement and assets in a trusted mobile account.',
        featureHashrate: 'Real hashrate access',
        featureHashrateDesc: 'Transparent node status, realtime hashrate data',
        featureDaily: 'Daily settlement',
        featureDailyDesc: 'Billed by effective hashrate, records are traceable',
        featureSecurity: 'Asset security',
        featureSecurityDesc: 'Wallet binding and multi-factor withdrawals',
        bindTitle: 'Bind invite address',
        bindConfirm: 'Confirm',
        bindPlaceholder: '0x000000000000000000000000000000',
    },
    mining: {
        title: 'Burn mining',
        subtitle: 'Activate hashrate and share ecosystem rewards',
        totalT: 'Total (T)',
        shareT: 'Shared',
        teamT: 'Team',
        burnT: 'Burned',
        validBurnT: 'Valid burned',
        renew: 'Renew',
        amountPlaceholder: 'Enter burn hashrate',
        token: 'Burn token',
        rate: 'Live rate',
        balance: 'Wallet balance',
        submit: 'Join burn mining',
        hint: 'You will get 1.002 burn hashrate',
        burnLog: 'Burn logs',
        shareLog: 'Shared',
        renewLog: 'Renewals',
        success: 'Success',
        fail: 'Failed',
        qty: 'Amount',
        hashrateT: 'Hashrate (T)',
        renewHashrate: 'Renew hashrate',
        renewFee: 'Renew fee',
        renewDate: 'Hashrate period',
        renewConvert: 'Converted',
        renewNote: 'Note',
        renewNoteText: 'Please renew before 2026.10.1, or mining rewards will stop.',
        renewConfirm: 'Confirm renew',
        ext1:'Reward Hashrate',
        ext2:'Mining Earnings',
        ext3:'Renewal Amount'
    },
    earnings: {
        balance: 'Balance',
        recharge: 'Deposit',
        withdraw: 'Withdraw',
        totalWithdraw: 'Total withdrawn',
        totalIncome: 'Total income',
        mineIncome: 'Mining income',
        referral: 'Referral',
        incomeLog: 'Income',
        rechargeLog: 'Deposits',
        withdrawLog: 'Withdrawals',
        qty: 'Amount',
        success: 'Success',
        pending: 'Pending',
        fail: 'Failed',
        1: 'Success',
        0: 'Pending',
        2: 'Failed',
        rechargeQty: 'Deposit amount',
        withdrawQty: 'Withdraw amount',
        receiveQty: 'Received',
        rechargeTitle: 'Deposit',
        withdrawTitle: 'Withdraw',
        rechargeMin: 'Min 10',
        minAmount: 'Min 100',
        toAccount: 'You receive',
        fee: 'Fee',
        rechargeAddress: 'Deposit address',
        address: 'Address',
        confirmRecharge: 'Confirm',
        confirmWithdraw: 'Confirm',
    },
    me: {
        inviteLink: 'Invite link',
        upline: 'Upline',
        inviteCount: 'Invites',
        teamCount: 'Team size',
        bigArea: 'Major area (T)',
        smallArea: 'Minor burn (T)',
        team: 'Team members',
        direct: 'Direct',
        indirect: 'Indirect',
        umbrella: 'Umbrella',
        burnT: 'Burn (T)',
        personT: 'Personal (T)',
        teamBurn: 'Team burn (T)',
        teamHash: 'Team hashrate (T)',
        remark: 'Note',
        setRemark: 'Set note',
        remarkPlaceholder: 'Enter a note',
        confirm: 'Confirm',
    },
    notice: {
        title: 'Announcement',
        headline: 'Headline headline headline headline',
        date: '2024-12-22',
        body: 'Dear user,\n\nXXX App will go live at 20:00 on 26 Nov 2024. The minimum subscription base will be updated accordingly. Please refer to the App for the final figure.\n\nThe iOS version is still in review, so Android will launch first.',
    },
};
